import * as Sentry from '@sentry/react-native';
import { isNetworkError } from './networkErrorUtils';

export function isExpectedOtpVerificationError(error: any): boolean {
    if (!error) return false;

    const message = error.message?.toLowerCase() || '';
    const code = error.code?.toLowerCase() || '';

    return code === 'otp_expired'
        || message.includes('token has expired or is invalid');
}

/**
 * Captures an exception to Sentry only if it's not a network error
 */
export function captureExceptionIfNotNetwork(error: any, context?: Parameters<typeof Sentry.captureException>[1]) {
    if (!isNetworkError(error)) {
        Sentry.captureException(error, context);
    } else {
        console.log('Skipping Sentry report for network error:', error.message);
    }
}
